<template>
  <div>
    <div class="top-area flex-center-between">签署记录</div>
    <div class="content">
      <div class="flex-center-between">
        <div class="title">全部签署</div>
        <el-input placeholder="请输入印章编码" v-model="searchForm.sealCode" clearable>
          <el-button slot="append" icon="el-icon-search" @click="loadData"></el-button>
        </el-input>
      </div>
      <el-table :data="tableData" style="width: 100%" class="mt20" height="480" v-loading="loading">
        <el-table-column prop="sealCode" label="印章编码" width="135"></el-table-column>
        <el-table-column prop="sealName" label="印章名称" min-width="250"></el-table-column>
        <el-table-column prop="docFileName" label="文档名称" width="180"></el-table-column>
        <el-table-column prop="docAbstract" label="文档内容摘要" width="180"></el-table-column>
        <el-table-column type="extData" label="扩展数据" width="135"></el-table-column>
        <el-table-column prop="signCase" label="签署场景" width="180"></el-table-column>
        <el-table-column prop="signIp" label="签署ip地址" width="180"></el-table-column>
        <el-table-column prop="createTime" label="签署时间" width="180"></el-table-column>
        <el-table-column prop="signer" label="签名者" width="180"></el-table-column>
        <template slot="empty">
          <div class="table_empty">
            <img src="@/assets/user/image-empty.png" />
            <div class="fc6">还没有签署记录哦</div>
          </div>
        </template>
      </el-table>
      <el-pagination class="ta-r mt15" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false
    };
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      let params = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        ...this.searchForm
      }
      // this.loading = true
      this.$http.get(this.$api.user.getSignatureLog, params).then(res => {
        // this.loading = false
        if (res.data.code == 200) {
          this.tableData = res.data.rows
          this.pagination.total = res.data.total
        }
      })
    },
    handleSizeChange(e) {
      this.pagination.pageSize = e
      this.loadData()
    },
    handleCurrentChange(e) {
      this.pagination.pageNum = e
      this.loadData()
    }
  }
};
</script>
<style lang="less" scoped>
.top-area {
  width: 100%;
  margin-top: 40px;
  padding: 40px 30px 0;
  border-radius: 4px;
  font-size: 40px;
  color: #fff;
}

.content {
  margin-top: 20px;
  padding: 20px 30px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
}

.title {
  border-top: 6px solid #407fff;
  width: 106px;
  font-weight: 400;
  font-size: 26px;
  color: #000;
  padding-top: 12px;
}

::v-deep .el-input-group {
  width: 290px;
}

::v-deep .el-input-group__append {
  background-color: #407fff;
}

::v-deep .el-icon-search:before {
  color: #fff;
}
</style>
